<template>
    <module-frame :module-id="moduleId">
        <div
            v-if="isEmptyProductInfo || (notAdded && !_manageMode)"
            :id="productNewDetailPanelId"
            class="productNewDetailPanel J_pd_detail"
            :data-content-type="knowPayConentTypeProperty"
        >
            <div
                :id="productDetailHeaderId"
                class="productDetailHeader detailHeaderColor"
                style="position: relative"
                :style="mobiTipsStyle"
            >
                <a
                    class="icon-gClose g_round g_iconMiddle proBack icon-defaultColor"
                    @click="back"
                ></a>
                <a
                    class="icon-gHome g_round g_iconMiddle proOther icon-defaultColor"
                    :href="linkLang"
                ></a>
            </div>
            <div class="productNotAdded productNotAdded-icon"></div>
            <div class="productNotAdded-tip">{{ productNotAdded }}</div>
        </div>
        <div
            v-else
            :id="productNewDetailPanelId"
            :class="productNewDetailPanelClass"
            :data-content-type="knowPayConentTypeProperty"
        >
            <!-- 头图按钮 -->
            <div :id="productDetailHeaderId" class="productDetailHeaderV3">
                <!-- 返回按钮 -->
                <span
                    v-show="fromQz"
                    class="icon-gClose g_round g_iconMiddle proBack"
                ></span>
                <!-- 分享按钮 -->
                <a
                    v-if="openShare === 0"
                    id="productDetailShare"
                    class="icon-share g_round g_iconMiddle proShare"
                ></a>
                <!-- 产品收藏 -->
                <a
                    v-if="isShowCollectionHeadIcon"
                    class="mallCollectionIcon shareBlock g_round"
                >
                    <div
                        class="icon-collection g_iconMiddle"
                        :class="collectionClass"
                    ></div>
                </a>
            </div>

            <div class="productNewDetail" :showSaleNoEnd="isNoEndTime">
                <div style="position: relative">
                    <div :id="productNewDetailSwipeId" class="proImgSwipe">
                        <div
                            class="proDetailImgBox"
                            :style="proDetailImgBoxStyle"
                        >
                            <template v-if="openKnowPayment">
                                <!-- 知识付费-视频 -->
                                <div
                                    v-if="isVideoPayProduct"
                                    class="knowPayProduct"
                                >
                                    <div
                                        class="proDetailImg J_img_lazyload"
                                        :class="imgZoomClass"
                                        :style="proDetailImgStyle"
                                        :src-original="picPath"
                                    >
                                        <template v-if="isFinPay">
                                            <div
                                                class="videoPlay faisco-icons-"
                                                @click="
                                                    checkKnowPayVideoHandler(
                                                        productId
                                                    )
                                                "
                                            ></div>
                                            <div
                                                id="knowproductVideoMask"
                                                style="display: none"
                                            >
                                                <div
                                                    class="mobiProductVideoDialog productKnowPayVideo"
                                                >
                                                    <video
                                                        id="knowPayVideo"
                                                        :style="
                                                            knowPayVideoStyle
                                                        "
                                                        class="mobiVideo"
                                                        controls
                                                        webkit-playsinline="true"
                                                        playsinline="true"
                                                        controlsList="nodownload"
                                                        preload="auto"
                                                    ></video>
                                                </div>
                                                <div
                                                    class="videoQuit"
                                                    @click="
                                                        productKnowPayVideoQuit
                                                    "
                                                >
                                                    <svg
                                                        class="videoQuit-close"
                                                    >
                                                        <use
                                                            href="#jzm-vicon_close"
                                                        ></use>
                                                    </svg>
                                                </div>
                                            </div>
                                        </template>
                                        <template v-else>
                                            <template v-if="finalOpener">
                                                <div
                                                    class="videoPlay faisco-icons-"
                                                    @click="
                                                        checkKnowPayVideoHandler(
                                                            productId,
                                                            finalOpener
                                                        )
                                                    "
                                                ></div>
                                                <div
                                                    class="videoTryTipContainer"
                                                >
                                                    <div
                                                        class="videoTryBg"
                                                    ></div>
                                                    <div class="videoTryTip">
                                                        <span
                                                            >可试看前{{
                                                                videoTryMin
                                                            }}分钟，购买后可收看完整内容</span
                                                        >
                                                    </div>
                                                </div>
                                                <div
                                                    id="knowproductVideoMask"
                                                    style="display: none"
                                                >
                                                    <div
                                                        class="mobiProductVideoDialog productKnowPayVideo"
                                                    >
                                                        <video
                                                            id="knowPayVideo"
                                                            :style="
                                                                knowPayVideoStyle
                                                            "
                                                            class="mobiVideo"
                                                            controls
                                                            webkit-playsinline="true"
                                                            playsinline="true"
                                                            controlsList="nodownload"
                                                            preload="auto"
                                                        ></video>
                                                    </div>
                                                    <div
                                                        class="videoQuit"
                                                        @click="
                                                            productKnowPayVideoQuit
                                                        "
                                                    >
                                                        <svg
                                                            class="videoQuit-close"
                                                        >
                                                            <use
                                                                href="#jzm-vicon_close"
                                                            ></use>
                                                        </svg>
                                                    </div>
                                                </div>
                                            </template>
                                            <template v-else>
                                                <div
                                                    class="videoPlay faisco-icons-"
                                                    @click="
                                                        checkKnowPayVideoHandler(
                                                            productId
                                                        )
                                                    "
                                                ></div>
                                                <div
                                                    id="knowproductVideoMask"
                                                    style="display: none"
                                                >
                                                    <div
                                                        class="mobiProductVideoDialog productKnowPayVideo"
                                                    ></div>
                                                    <div
                                                        class="videoQuit"
                                                        @click="
                                                            productKnowPayVideoQuit
                                                        "
                                                    >
                                                        <svg
                                                            class="videoQuit-close"
                                                        >
                                                            <use
                                                                href="#jzm-vicon_close"
                                                            ></use>
                                                        </svg>
                                                    </div>
                                                </div>
                                            </template>
                                        </template>
                                    </div>
                                </div>
                                <!-- 知识付费-图文、专栏 -->
                                <template
                                    v-else-if="
                                        isPicTextProduct || isColumnProduct
                                    "
                                >
                                    <template v-if="picPathList.length !== 0">
                                        <div
                                            v-for="pic in picPathList"
                                            class="swipImgBox"
                                        >
                                            <div
                                                class="proDetailImg J_img_lazyload"
                                                :class="imgZoomClass"
                                                :vwidth="pic.width"
                                                :vheight="pic.height"
                                                :alt="productName"
                                                :data-picId="pic.picId"
                                                :style="proDetailImgStyle"
                                                :src-original="pic.newPath"
                                            >
                                            </div>
                                        </div>
                                    </template>
                                    <template v-else>
                                        <div>
                                            <div
                                                class="proDetailImg J_img_lazyload"
                                                :class="imgZoomClass"
                                                :style="proDetailImgStyle"
                                                :src-original="defaultPath"
                                            >
                                            </div>
                                        </div>
                                    </template>
                                </template>
                                <!-- 知识付费-音频 -->
                                <div
                                    v-else-if="isAudioProduct"
                                    id="productAudioPlayer"
                                >
                                    <product-audio-player
                                        :pic-path="productAudioPicPath"
                                        :is-default-color-style="
                                            isDefaultColorStyle
                                        "
                                        :audio-try-min="audioTryMin"
                                        :follow-color="followColor"
                                        :img-zoom-class="imgZoomClass"
                                        :is-fin-pay="isFinPay"
                                        :istry-open="istryOpen"
                                        :is-use-custom-color="isUseCustomColor"
                                        :is-v1="isV1"
                                        :product-id="productId"
                                    ></product-audio-player>
                                </div>
                            </template>

                            <!-- 头图 -->
                            <template v-else>
                                <!-- 多张头图 -->
                                <template v-if="picPathList.length !== 0">
                                    <div
                                        v-for="(pic, index) in picPathList"
                                        class="swipImgBox"
                                    >
                                        <div
                                            class="proDetailImg J_img_lazyload"
                                            :class="imgZoomClass"
                                            :vwidth="pic.width"
                                            :vheight="pic.height"
                                            :alt="productName"
                                            :src-original="pic.newPath"
                                            :data-picId="pic.id"
                                            :style="proDetailImgStyle"
                                        >
                                        </div>
                                        <!-- 主图视频 -->
                                        <template
                                            v-if="showVideo && index === 0"
                                        >
                                            <div
                                                class="videoPlay faisco-icons-"
                                                @click="playVideo"
                                            ></div>
                                            <div
                                                id="productVideoMask"
                                                class="productVideoMask"
                                                style="display: none"
                                            >
                                                <div
                                                    class="mobiProductVideoDialog"
                                                >
                                                    <video
                                                        id="productVideo"
                                                        :style="
                                                            knowPayVideoStyle
                                                        "
                                                        class="mobiVideo"
                                                        controls
                                                        ><source
                                                            :src="flvPagePath"
                                                            type="video/mp4"
                                                        />抱歉，您的浏览器不能查看该视频。</video
                                                    >
                                                </div>
                                                <div
                                                    class="videoQuit"
                                                    @click="quitVideo"
                                                >
                                                    <svg
                                                        class="videoQuit-close"
                                                    >
                                                        <use
                                                            href="#jzm-vicon_close"
                                                        ></use>
                                                    </svg>
                                                </div>
                                            </div>
                                        </template>
                                    </div>
                                </template>
                                <!-- 没有头图 -->
                                <template v-else>
                                    <div>
                                        <div
                                            class="proDetailImg J_img_lazyload"
                                            :class="imgZoomClass"
                                            :style="proDetailImgStyle"
                                            :src-original="defaultPath"
                                        ></div>
                                    </div>
                                </template>
                            </template>
                        </div>
                        <!-- 头图轮播切换按钮 -->
                        <div
                            v-if="picPathList.length > 1 && pageStyle != 1"
                            id="productBullet"
                            class="productBullet"
                        >
                            <ul id="bullets" class="bullets">
                                <li
                                    v-for="(item, index) in picPathList"
                                    :class="{ on: index === 0 }"
                                ></li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div class="themeV3ProductWrap">
                    <template
                        v-if="
                            mallPriceHtml !== '' ||
                            mallMarketPriceHtml !== '' ||
                            collectionHtml !== ''
                        "
                    >
                        <!-- 产品价格 -->
                        <!-- TODO: HTML模板抽离 -->
                        <div
                            :class="productPriceClass"
                            v-html="mallPriceHtml + mallMarketPriceHtml"
                        ></div>
                    </template>
                    <div
                        class="productNameDescBox"
                        :style="productNameDescBoxStyle"
                    >
                        <h1 class="productNameText">
                            {{ productName }}
                        </h1>
                        <!-- 收藏和分享按钮-最后一个样式 -->
                        <div class="mallProductToolBtns">
                            <span
                                v-if="openShare === 0"
                                id="productDetailShare2"
                                class="mallShareIcon icon-share proShare icon-defaultColor"
                            ></span>
                            <div
                                v-if="collectionHtml !== ''"
                                class="mallCollectionIcon shareBlock"
                            >
                                <div
                                    class="icon-collection"
                                    :class="collectionClass"
                                ></div>
                            </div>
                        </div>
                    </div>
                    <!-- 产品简介 -->
                    <div
                        v-if="showPointDesc"
                        :class="salePointDescClass"
                        v-html="salePointDesc"
                    ></div>
                </div>
                <!-- 产品保证 -->
                <div
                    v-if="productGuaranteeOpen"
                    id="guaranteeContent"
                    class="productGuarantee J_guarantee"
                >
                    <div
                        v-for="guarantee in guaranteeList"
                        v-if="guarantee.show"
                        class="guaranteeName"
                    >
                        <i class="icon-guarantee g_main_color_v3"></i>
                        {{ guarantee.name }}
                    </div>
                    <div class="faisco-icons-forward1 g_middleColor more"></div>
                </div>

                <!-- 产品保证详情面板 -->
                <div
                    v-if="productGuaranteeOpen"
                    id="productGuaranteePanel"
                    class="productGuaranteePanel"
                    style="display: none"
                >
                    <div id="closeProductGuarantee" style="height: 100%"></div>
                    <div class="productGuaranteeContentPanel">
                        <div class="title">{{ productWarranty }}</div>
                        <div class="productGuaranteeContent">
                            <div
                                v-for="guarantee in guaranteeList"
                                v-if="guarantee.show"
                                class="guaranteeItem"
                            >
                                <div class="guaranteeName"
                                    ><i
                                        class="icon-guarantee g_main_color_v3"
                                    ></i
                                    >{{ guarantee.name }}</div
                                >
                                <div
                                    v-if="guarantee.e"
                                    class="guaranteeContent"
                                    v-html="guarantee.e"
                                ></div>
                            </div>
                        </div>
                        <div
                            id="closePdGuaranteeIcon"
                            class="productDetailClose icon-Off g_iconMiddle icon-defaultColor"
                        ></div>
                    </div>
                </div>

                <div class="productItemSeparator g_breakline"></div>
                <!-- 购物选项列表 -->
                <div
                    v-if="mallOptionsOpen"
                    id="productInfoSize"
                    class="proCommProperty productInfoSize borderClass"
                >
                    <span
                        class="productParamterNameList pdInfoTitle"
                        v-text="LS.select"
                    ></span>
                    <span class="productParamterWords">{{
                        productParamterNameList
                    }}</span>
                    <span
                        class="choiceProductSize icon-gGoforward g_iconMiddle"
                    ></span>
                </div>
                <div
                    v-if="mallOptionsOpen"
                    class="productItemSeparator g_breakline"
                ></div>
                <div v-if="showFileDownload" class="detail_file_download">
                    <span
                        class="label"
                        v-text="downloadModel.downloadBtnText"
                    ></span>
                    <span
                        class="filename"
                        v-text="downloadModel.fileName"
                    ></span>
                    <a :href="downloadModel.downloadUrl" @click="downloadClick">
                        <svg class="download">
                            <use href="#download"></use>
                        </svg>
                    </a>
                </div>
                <div
                    v-if="showFileDownload"
                    class="productItemSeparator g_breakline"
                ></div>
                <div
                    :id="productDetailTabPanelClass"
                    class="productDetailTabPanel"
                    :class="btnSpaceClass"
                    :style="btnSpaceStyle"
                >
                    <ul id="productTabUl" class="tabUl" :style="mobiTipsStyle">
                        <div class="tabUiDiv">
                            <!--  TODO:将html逻辑移动到前端 -->
                            <div
                                class="tabUiDiv2"
                                :style="tabLiDivStyle"
                                v-html="tabHeadHtml"
                            >
                            </div>
                        </div>
                    </ul>
                    <!--  TODO:将html逻辑移动到前端 -->
                    <html-render
                        ref="tabBody"
                        class="tabBody"
                        :html="tabBodyHtml"
                    ></html-render>
                </div>

                <!-- 底部区域 -->
                <div
                    id="productBottomBox"
                    class="productBottomBox"
                    :style="productBottomBoxStyle"
                >
                    <div class="productMallShop" :class="btnStyle">
                        <!-- 首页按钮 -->
                        <a
                            v-if="openIndex"
                            class="J_homeBtn homeBtn funBtn"
                            :href="linkLang + '/index.jsp'"
                        >
                            <div class="homeBtnInner">
                                <div class="icon-homeBtn homeBtnIcon"></div>
                                <span class="homeBtnText btnText">{{
                                    homePage
                                }}</span>
                            </div>
                        </a>
                        <!-- 客服按钮 -->
                        <div
                            v-if="openService === 0"
                            id="serviceBtn"
                            class="serviceBtn funBtn"
                        >
                            <div class="serviceInner">
                                <div
                                    class="icon-serviceBtn serviceBtnIcon"
                                ></div>
                                <span class="serviceBtnText btnText">{{
                                    mobiService
                                }}</span>
                            </div>
                        </div>

                        <div class="btnGroup" :style="btnGroupStyle">
                            <template v-if="!openKnowPayment">
                                <!-- 立即咨询按钮 -->
                                <a
                                    v-if="immediatelyConsultOpen"
                                    id="consultImmediatelyBtn"
                                    :href="advisoryUrl"
                                    class="consultImmediatelyBtn g_mallButton J_consultImmediatelyBtn"
                                    :class="consultDefaultColor"
                                    :_pid="productId"
                                >
                                    {{ advisoryTxt }}
                                </a>
                                <!-- 立即预约按钮 -->
                                <div
                                    v-if="bookingOpen || productFormOpen"
                                    id="J_productBookingBtn"
                                    class="bookingAddCartBtn productImmediatelyBug g_mallButton J_productBookingBtn g_main_bgColor_v3"
                                    :_pid="productId"
                                    @click="bookingButtonClickHandler"
                                    v-html="shopBtnTypeText"
                                >
                                </div>
                            </template>
                            <template v-else>
                                <!-- 知识付费-专栏按钮 -->
                                <div
                                    v-if="isBelongToColumnProduct"
                                    id="J_courseCatalogBtn"
                                    class="course_catalog_btn g_mallButton g_minor1_bgColor_v3"
                                    >课程目录</div
                                >
                                <!-- 知识付费-按钮 -->
                                <div
                                    v-if="isFinPay"
                                    id="J_productKnowPayBtn"
                                    class="bookingAddCartBtn g_main_bgColor_v3 g_mallButton productKnowPayBtn"
                                    style="opacity: 0.5"
                                >
                                    {{ knowPaymentText }}</div
                                >
                                <div
                                    v-else
                                    id="J_productKnowPayBtn"
                                    class="bookingAddCartBtn g_main_bgColor_v3 g_mallButton productKnowPayBtn"
                                    @click="productKnowPayBtnClickHandler"
                                >
                                    {{ knowPaymentText }}
                                </div>
                            </template>
                        </div>
                    </div>
                </div>
            </div>

            <!-- 产品评论 TODO: 这里会用js移动节点位置，可以优化 -->
            <div
                id="userCommentPanel"
                class="userCommentPanel"
                style="display: none"
            >
                <div class="userCommentHead">
                    <span
                        class="userCommentGoBack icon-gClose g_iconMiddle"
                    ></span>
                    {{ mobiPostComments }}
                    <a
                        class="userCommentGoHome icon-gHome g_iconMiddle"
                        :href="linkLang"
                    >
                    </a>
                </div>
                <div class="userCommentBody">
                    <!-- 登录评论、匿名评论tab -->
                    <ul v-if="!isOnlyMember" class="tabUl">
                        <li
                            id="tabUserLi1"
                            class="tabLi tabActive g_main_color_v3 g_main_bdColor_v3"
                            data="1"
                            >{{ mobiLogComments }}</li
                        >
                        <li id="tabUserLi2" class="tabLi" data="2">{{
                            mobiIncognitoComments
                        }}</li>
                    </ul>
                    <div class="tabBody">
                        <!-- 登录评论 -->
                        <div id="tabUserPanel1" class="tabPanel tabPanelAtive">
                            <div v-if="_manageMode" class="notice"
                                >您目前处于网站管理状态，请先退出再评论</div
                            >
                            <div class="userCommentInfo">
                                <div class="g_globalLine">
                                    <input
                                        v-if="_sessionMemberId <= 0"
                                        id="user"
                                        type="text"
                                        maxlength="50"
                                        class="itemEdit g_input"
                                        :placeholder="
                                            mobiMemberPleaseInput +
                                            mobiMemberAccount
                                        "
                                    />
                                    <input
                                        v-else
                                        id="user"
                                        type="text"
                                        maxlength="50"
                                        disabled="true"
                                        :value="memberName"
                                        class="itemEdit g_input"
                                        :minlength="CREATOR_MINLEN"
                                        :placeholder="
                                            mobiMemberPleaseInput +
                                            mobiMemberAccount
                                        "
                                    />
                                    <span class="icon-mnameIcon"></span>
                                </div>

                                <div
                                    v-if="_sessionMemberId <= 0"
                                    class="g_globalLine"
                                >
                                    <input
                                        id="password"
                                        type="password"
                                        autocomplete="off"
                                        maxlength="20"
                                        class="itemEdit g_input"
                                        :placeholder="
                                            mobiMemberPleaseInput +
                                            mobiMemberPassword
                                        "
                                    />
                                    <span class="icon-mpswIcon"></span>
                                </div>

                                <div
                                    v-if="openCommStar"
                                    class="l-star-list J-star-list"
                                    _star="5"
                                >
                                    <li class="faisco-icons-star3"></li>
                                    <li class="faisco-icons-star3"></li>
                                    <li class="faisco-icons-star3"></li>
                                    <li class="faisco-icons-star3"></li>
                                    <li class="faisco-icons-star3"></li>
                                    <li class="score-tip"></li>
                                </div>

                                <div id="userCommentRemarkPanel1">
                                    <div class="g_globalLine">
                                        <textarea
                                            id="userCommentRemark"
                                            class="itemEdit msgIcon g_textArea icon-msgIcon"
                                            :minlength="COMMENT_MINLEN"
                                            :maxlength="COMMENT_MAXLEN"
                                            :placeholder="
                                                mobiMemberPleaseInput +
                                                msgBoardContent
                                            "
                                        ></textarea>
                                        <span class="icon-mmsgIcon"></span>
                                    </div>
                                    <div
                                        class="g_globalLine J_productCommImg upImgSet"
                                    >
                                        <table
                                            id="pt_add_img_tb"
                                            cellpadding="0"
                                            cellspacing="0"
                                        >
                                            <tbody>
                                                <tr>
                                                    <td
                                                        id="pt_add_img_tb"
                                                        class="comm-find-tb"
                                                        :maxNum="
                                                            COMMENT_UP_IMG_MAX_NUM
                                                        "
                                                    >
                                                        <div
                                                            id="comm-img-swfu-placeholder"
                                                        ></div>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>

                                <div
                                    id="userCommentLoginAndComform"
                                    class="userCommentComform g_button g_main_bgColor_v3"
                                    >{{ mobiSubmit }}</div
                                >
                            </div>
                        </div>
                        <!-- 匿名评论 -->
                        <div
                            v-if="!isOnlyMember"
                            id="tabUserPanel2"
                            class="tabPanel"
                        >
                            <div v-if="_manageMode" class="notice"
                                >您目前处于网站管理状态，请先退出再评论</div
                            >
                            <div id="userCommentInfo2" class="userCommentInfo">
                                <div class="g_globalLine">
                                    <input
                                        id="anonymityCommentUser"
                                        type="text"
                                        maxlength="50"
                                        class="itemEdit g_input"
                                        :placeholder="
                                            mobiMemberPleaseInput +
                                            productCommentCreator
                                        "
                                    />
                                    <span class="icon-mnameIcon"></span>
                                </div>

                                <div
                                    v-if="openCommStar"
                                    class="l-star-list J-star-list"
                                    _star="5"
                                >
                                    <li class="faisco-icons-star3"></li>
                                    <li class="faisco-icons-star3"></li>
                                    <li class="faisco-icons-star3"></li>
                                    <li class="faisco-icons-star3"></li>
                                    <li class="faisco-icons-star3"></li>
                                    <li class="score-tip"></li>
                                </div>
                                <div id="userCommentRemarkPanel2"></div>
                                <div
                                    id="anonymityCommentComform"
                                    class="userCommentComform g_button g_main_bgColor_v3"
                                    >{{ mobiSubmit }}</div
                                >
                            </div>
                        </div>
                        <input
                            id="postCommentId"
                            type="hidden"
                            :value="productId"
                        />
                    </div>
                </div>
            </div>

            <!-- 购物选项：TODO 这里会用js移动节点位置，可以优化 -->
            <div
                id="productMallOptionPanel"
                class="productMallOptionPanel"
                :class="isForeignVer"
                style="display: none"
            >
                <div class="productMallOptionContentPanel">
                    <div
                        class="productMallOptionContent"
                        :style="productMallOptionContentStyle"
                    >
                        <!-- 购物选项头部 -->
                        <div class="productMallOptionHead">
                            <div
                                class="J_mallOptionImg mallOptionImg"
                                :picId="firstPicId"
                                :style="
                                    'background-image:url(' + firstNewPath + ')'
                                "
                            ></div>
                            <div class="productDetail">
                                <!-- TODO: html移除 -->
                                <div
                                    class="productDetailPrice"
                                    v-html="mallPriceHtml2"
                                ></div>
                            </div>
                            <div
                                class="productDetailClose icon-Off g_iconMiddle icon-defaultColor"
                            ></div>
                        </div>
                        <!-- 构想选项SKU -->
                        <div
                            v-if="showOptionList.length"
                            id="mallOptionAndNumContainer"
                            class="mallOptionAndNumBox"
                        >
                            <div id="mallOptionAndNumBox">
                                <!-- 购物选项组合 -->
                                <div
                                    class="mallNewOptionBox mallOptionBox J-op-box"
                                    v-html="mallNewOptionBoxHtml"
                                >
                                </div>

                                <div
                                    :id="productDetailOptSwipeId"
                                    class="proImgSwipe"
                                >
                                    <div
                                        class="proDetailImgBox"
                                        style="display: none"
                                    >
                                        <div class="swipImgBox">
                                            <div
                                                v-for="optionPic in optionPicList"
                                                class="proDetailImg"
                                                :class="imgZoomClass"
                                                :vwidth="optionPic.width"
                                                :vheight="optionPic.height"
                                                :alt="productName"
                                                :data-picId="optionPic.picId"
                                                :style="proDetailImgStyle"
                                                :src-original="
                                                    optionPic.newPath
                                                "
                                            >
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div
                                    class="g_separator separatorLine"
                                    style="margin: 0 0.75rem"
                                ></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </module-frame>
</template>

<script>
import { showTopTips } from '@/shared/tips';
import { initProductOptions } from '@/modules/shared/product/productOptions';
import { consultImmediatelyBtnClick } from '@/modules/shared/product/consultImmediate';
import {
    bookingPanelClickEvent,
    setMemberPriceLabelColot2ThemeBackgroundColor,
    initOptionsStr,
} from '@/modules/shared/product/product';
import { bindImgLazyLoad } from '@/shared/imageLazyload';
import { initMbPdCollection } from '@/modules/shared/product/collection';
import { initVideo } from '@/modules/shared/product/video';
import { initProductSwipe } from '@/modules/shared/product/swipe';
import { initPbCommUploadImgParam } from '@/modules/shared/product/upload';
import { initPictureSlidesV4 } from '@/shared/photo/slides';
import { banCurPageContentCopy } from '@/shared/util';
import {
    showNewMarketPrice,
    setMarketingProPdStyle,
} from '@/modules/shared/product/layout';
import { productGuaranteeEventInit } from '@/modules/shared/product/guarantee';
import { initCourseCatalog } from '@/modules/shared/product/knowPay/column';
import { setStarSelect } from '@/modules/shared/product/star';
import {
    fixPorductDetailStyle,
    initCustab,
} from '@/modules/shared/product/detail';
import { allFixWXPA } from '@/system/shared/mobiPATipFix';
import { initShowMallOptionImg } from '@/modules/shared/product/productOptions';
import { bindServiceBtnEvent } from '@/modules/shared/product/btn';
import { videoQuit } from '@/features/global-mobi-function/methods/share';
import { getProductVideo } from '@/modules/shared/product/video';
import { productNewDetailEventInitV3 } from '@/modules/shared/product/productV3';
import { productFormBtnClick } from '@/modules/shared/product/btn';
import {
    checkKnowPayVideo,
    productKnowPayVideoQuit,
} from '@/modules/shared/product/knowPay/video';
import { mapGetters, mapMutations, mapState } from 'vuex';
import ModuleFrame from '@/modules/frame/index.vue';
import { setHrefEventHasReqArgs } from '@/modules/comm';
import { productKnowPayBtnClick } from '@/modules/shared/product/knowPay/btn';
import productAudioPlayer from '../../components/productAudioPlayer.vue';
import { COL } from '@/def/col';
import { TEMPLATE_LAYOUT } from '@/def/template';
import { goBack } from '@/features/router/universal';
import { encodeHtml, decodeHtml } from '@/shared/util';

import HtmlRender from '@/components/html-render/index.vue';
import { MOBILE_AUTH_TIPS } from '@/services';
import { ing } from '@/shared/tips';

export default {
    components: {
        ModuleFrame,
        productAudioPlayer,
        HtmlRender,
    },
    props: {
        moduleId: {
            type: Number,
            default: -1,
        },
    },
    data() {
        return {
            fromQz: true,
        };
    },
    computed: {
        ...mapState('app', [
            'openThemeV3',
            'colId',
            'templateLayoutId',
            'LS',
            'realNameAuth',
        ]),
        ...mapState(['mobiTipList']),
        ...mapGetters(['getModuleById']),
        module() {
            return this.getModuleById(this.moduleId);
        },
        productNewDetailPanelId() {
            return `productNewDetailPanel${this.moduleId}`;
        },
        productDetailHeaderId() {
            return `productDetailHeader${this.moduleId}`;
        },
        productNewDetailSwipeId() {
            return `productNewDetailSwipe${this.moduleId}`;
        },
        knowPayConentTypeProperty() {
            return this.isKnowPayProduct ? this.payContentType : '';
        },
        productNewDetailPanelClass() {
            return [
                'productNewDetailPanel',
                'J_pd_detail',
                'pdThemev3',
                'detailPanelV3',
                this.classForIphoneX,
                this.productPageStyle,
                this.isForeignVer,
            ];
        },
        proDetailImgBoxStyle() {
            return this.pageStyle == 1 ? 'display:none;' : '';
        },
        proDetailImgStyle() {
            return {
                height: `${Math.ceil(
                    16 * ((this.f_height * 1.0) / this.f_width)
                )}rem`,
                [`background-image`]: `url(${this.loadingPath})`,
            };
        },
        productPriceClass() {
            const tmp = ['proCommProperty', 'productPrice'];

            if (
                !(this.memberMinPrice === '' && this.memberMaxPrice === '') &&
                this.authorization
            ) {
                tmp.push('proCommPropertyPrice');
            }

            if (this.isBeginTimeGroundDown) {
                tmp.push('isShowOldSaleCountDown');
            }

            return tmp;
        },
        productNameDescBoxStyle() {
            return this.isShowProSignValue && this.showNewMarketPrice
                ? 'padding: 1.5rem 0 0.5rem 0;'
                : '';
        },
        productDetailTabPanelClass() {
            return `productDetailTabPanel${this.moduleId}`;
        },
        btnSpaceStyle() {
            return this.productTabs === 0 ? 'display:none;' : '';
        },
        productBottomBoxStyle() {
            return this.hideBottomBox ? 'display:none;' : '';
        },
        btnGroupStyle() {
            return this.mallOpen ||
                this.bookingOpen ||
                this.immediatelyConsultOpen ||
                this.productFormOpen ||
                this.openKnowPayment
                ? ''
                : 'display:none';
        },

        extInfo() {
            return this.module.extInfo;
        },
        isEmptyProductInfo() {
            return (
                this.isEmpty(this.extInfo.productInfo) ||
                this.productInfo.id <= 0
            );
        },
        notAdded() {
            return this.extInfo.notAdded;
        },
        _manageMode() {
            return VITE_APP_MODE !== 'visitor';
        },
        isKnowPayProduct() {
            return this.extInfo.isKnowPayProduct;
        },
        payContentType() {
            return this.extInfo.payContentType;
        },
        productNotAdded() {
            return this.extInfo.productNotAdded;
        },
        linkLang() {
            return this.extInfo.linkLang;
        },
        classForIphoneX() {
            return this.extInfo.classForIphoneX;
        },
        productPageStyle() {
            return this.extInfo.productPageStyle;
        },
        isForeignVer() {
            return this.extInfo.isForeignVer;
        },
        isShowCollectionHeadIcon() {
            return this.extInfo.isShowCollectionHeadIcon;
        },
        openShare() {
            return this.extInfo.openShare;
        },
        isNoEndTime() {
            return this.extInfo.isNoEndTime;
        },
        pageStyle() {
            return this.extInfo.pageStyle;
        },
        picPathList() {
            return this.extInfo.picPathList || [];
        },
        productName() {
            return this.extInfo.productName;
        },
        imgZoomClass() {
            return this.extInfo.imgZoomClass;
        },
        loadingPath() {
            return this.extInfo.loadingPath;
        },
        showVideo() {
            return this.extInfo.showVideo;
        },
        flvPagePath() {
            return this.extInfo.flvPagePath;
        },
        memberMinPrice() {
            return this.extInfo.memberMinPrice;
        },
        memberMaxPrice() {
            return this.extInfo.memberMaxPrice;
        },
        authorization() {
            return this.extInfo.authorization;
        },
        isShowProSignValue() {
            return this.extInfo.isShowProSignValue;
        },
        showNewMarketPrice() {
            return this.extInfo.showNewMarketPrice;
        },
        productWarranty() {
            return this.extInfo.productWarranty;
        },
        productGuaranteeOpen() {
            return this.extInfo.productGuaranteeOpen;
        },
        mallOptionsOpen() {
            return this.extInfo.mallOptionsOpen;
        },
        productParamterNameList() {
            return this.extInfo.productParamterNameList;
        },
        btnSpaceClass() {
            return this.extInfo.btnSpaceClass;
        },
        productTabs() {
            return this.extInfo.productTabs;
        },
        tabLiDivStyle() {
            return this.extInfo.tabLiDivStyle;
        },
        hideBottomBox() {
            return this.extInfo.hideBottomBox;
        },
        btnStyle() {
            return this.extInfo.btnStyle;
        },
        homePage() {
            return this.extInfo.homePage;
        },
        mobiService() {
            return this.extInfo.mobiService;
        },
        mallOpen() {
            return this.extInfo.mallOpen;
        },
        bookingOpen() {
            return this.extInfo.bookingOpen;
        },
        immediatelyConsultOpen() {
            return this.extInfo.immediatelyConsultOpen;
        },
        productFormOpen() {
            return this.extInfo.productFormOpen;
        },
        openKnowPayment() {
            return this.extInfo.openKnowPayment;
        },
        advisoryTxt() {
            return this.extInfo.advisoryTxt;
        },
        shopBtnTypeText() {
            return this.extInfo.shopBtnTypeText;
        },
        isBelongToColumnProduct() {
            return this.extInfo.isBelongToColumnProduct;
        },
        knowPaymentText() {
            return this.extInfo.knowPaymentText;
        },
        mobiPostComments() {
            return this.extInfo.mobiPostComments;
        },
        mobiLogComments() {
            return this.extInfo.mobiLogComments;
        },
        mobiIncognitoComments() {
            return this.extInfo.mobiIncognitoComments;
        },
        _sessionMemberId() {
            return this.extInfo._sessionMemberId;
        },
        mobiMemberPleaseInput() {
            return this.extInfo.mobiMemberPleaseInput;
        },
        mobiMemberAccount() {
            return this.extInfo.mobiMemberAccount;
        },
        mobiMemberPassword() {
            return this.extInfo.mobiMemberPassword;
        },
        COMMENT_MINLEN() {
            return this.extInfo.COMMENT_MINLEN;
        },
        COMMENT_MAXLEN() {
            return this.extInfo.COMMENT_MAXLEN;
        },
        COMMENT_UP_IMG_MAX_NUM() {
            return this.extInfo.COMMENT_UP_IMG_MAX_NUM;
        },
        mobiSubmit() {
            return this.extInfo.mobiSubmit;
        },
        productCommentCreator() {
            return this.extInfo.productCommentCreator;
        },
        firstPicId() {
            return this.extInfo.firstPicId;
        },
        firstNewPath() {
            return this.extInfo.firstNewPath;
        },
        siteFormPleaseSelect() {
            return this.extInfo.siteFormPleaseSelect;
        },
        productDetailOptSwipeId() {
            return `productDetailOptSwipe${this.moduleId}`;
        },
        productOptionFieldKey() {
            return this.extInfo.productOptionFieldKey;
        },
        productOptionName() {
            return this.extInfo.productOptionName;
        },
        productOptionType() {
            return this.extInfo.productOptionType;
        },
        isFinPay() {
            return this.extInfo.isFinPay;
        },
        finalOpener() {
            return this.extInfo.finalOpener;
        },
        videoTryMin() {
            return this.extInfo.videoTryMin;
        },
        picPath() {
            return this.extInfo.picPath;
        },
        mallNewOptionBoxHtml() {
            return this.extInfo.mallNewOptionBoxHtml;
        },
        pdAward() {
            return this.extInfo.pdAward;
        },
        viewAllow() {
            return this.extInfo.viewAllow;
        },
        hasThirdCode() {
            return this.extInfo.hasThirdCode;
        },
        oem() {
            return this.extInfo.oem;
        },
        sessionMid() {
            return this.extInfo.sessionMid;
        },
        collectionList() {
            return this.extInfo.collectionList;
        },
        isOpenActivity() {
            return this.extInfo.isOpenActivity;
        },
        choiceCurrencyValPure() {
            return this.extInfo.choiceCurrencyValPure;
        },
        finallyShowPrices() {
            return this.extInfo.finallyShowPrices;
        },
        isBanCopy() {
            return this.extInfo.isBanCopy;
        },
        optionSlidePicList() {
            return this.extInfo.optionSlidePicList || [];
        },
        productAudioPlayerOption() {
            return this.extInfo.productAudioPlayerOption;
        },
        bssKnowProductType() {
            return this.extInfo.bssKnowProductType;
        },
        isBelongToKnowPayProductAndOpenKnowPayProduct() {
            return this.extInfo.isBelongToKnowPayProductAndOpenKnowPayProduct;
        },
        isInitProductSwipe() {
            return this.extInfo.isInitProductSwipe;
        },
        COMMENT_UP_IMG_MAX_SIZE() {
            return this.extInfo.COMMENT_UP_IMG_MAX_SIZE;
        },
        COMMENT_UP_IMG_TYPE_VALId() {
            return this.extInfo.COMMENT_UP_IMG_TYPE_VALId;
        },
        siteMainDomain() {
            return this.extInfo.siteMainDomain;
        },
        proSelSignValue() {
            return this.extInfo.proSelSignValue;
        },
        usedAdvisoryMethod() {
            return this.extInfo.usedAdvisoryMethod;
        },
        advisoryPhone() {
            return this.extInfo.advisoryPhone;
        },
        wechatImgPath() {
            return this.extInfo.wechatImgPath;
        },
        mobiAdvisoryIde() {
            return this.extInfo.mobiAdvisoryIde;
        },
        belongToColumnProductId() {
            return this.extInfo.belongToColumnProductId;
        },
        btngroupText() {
            return this.extInfo.btngroupText;
        },
        optionsInfo() {
            return this.extInfo.optionsInfo;
        },
        oldOptionsStr() {
            return this.extInfo.oldOptionsStr;
        },
        productRecommentData() {
            return this.extInfo.productRecommentData;
        },
        recommendProOpen() {
            return this.extInfo.recommendProOpen;
        },
        openCommStar() {
            return this.extInfo.openCommStar;
        },
        shareDataProdectDetail() {
            return this.extInfo.shareDataProdectDetail;
        },
        argsParam() {
            return this.extInfo.argsParam;
        },
        wxOpen() {
            return this.extInfo.wxOpen;
        },
        exportData() {
            return this.extInfo.exportData;
        },
        issetMemberPriceLabelColot2ThemeBackgroundColor() {
            return this.extInfo.issetMemberPriceLabelColot2ThemeBackgroundColor;
        },
        openService() {
            return this.extInfo.openService;
        },
        f_width() {
            return this.extInfo.f_width;
        },
        f_height() {
            return this.extInfo.f_height;
        },
        isBeginTimeGroundDown() {
            return this.extInfo.isBeginTimeGroundDown;
        },
        defaultPath() {
            return this.extInfo.defaultPath;
        },
        mallMarketPriceHtml() {
            return this.extInfo.mallMarketPriceHtml ?? '';
        },
        mallPriceHtml() {
            return this.extInfo.mallPriceHtml ?? '';
        },
        collectionHtml() {
            return this.extInfo.collectionHtml ?? '';
        },
        tabHeadHtml() {
            return this.extInfo.tabHeadHtml;
        },
        tabBodyHtml() {
            return this.extInfo.tabBodyHtml;
        },
        choiceCurrencyVal() {
            return this.extInfo.choiceCurrencyVal;
        },
        productId() {
            return this.extInfo.productId;
        },
        productInfo() {
            return this.extInfo.productInfo;
        },
        isOnlyMember() {
            return this.extInfo.isOnlyMember;
        },
        msgBoardContent() {
            return this.extInfo.msgBoardContent;
        },
        mallPriceHtml2() {
            return this.extInfo.mallPriceHtml2;
        },
        showOptionList() {
            return this.extInfo.showOptionList;
        },
        pdNotFound() {
            return this.extInfo.pdNotFound;
        },
        guaranteeList() {
            let list = this.extInfo.guaranteeList || [];
            return list.map((item) => {
                item.e = encodeHtml(decodeHtml(item.e));
                return item;
            });
        },
        optionPicList() {
            return this.extInfo.optionPicList;
        },
        consultDefaultColor() {
            return this.extInfo.consultDefaultColor;
        },
        isVideoPayProduct() {
            return this.extInfo.isVideoPayProduct;
        },
        isPicTextProduct() {
            return this.extInfo.isPicTextProduct;
        },
        isAudioProduct() {
            return this.extInfo.isAudioProduct;
        },
        isColumnProduct() {
            return this.extInfo.isColumnProduct;
        },
        productAudioPicPath() {
            return this.productAudioPlayerOption.picPath;
        },
        isDefaultColorStyle() {
            return this.productAudioPlayerOption.isDefaultColorStyle;
        },
        audioTryMin() {
            return this.productAudioPlayerOption.audioTryMin;
        },
        followColor() {
            return this.productAudioPlayerOption.followColor;
        },
        istryOpen() {
            return this.productAudioPlayerOption.istryOpen;
        },
        isV1() {
            return this.productAudioPlayerOption.isV1;
        },
        isUseCustomColor() {
            return this.productAudioPlayerOption.isUseCustomColor;
        },
        openIndex() {
            return this.module.content.oi === 0;
        },
        advisoryUrl() {
            return this.usedAdvisoryMethod === 3 &&
                this.extInfo.advisoryUrl !== ''
                ? this.extInfo.advisoryUrl
                : null;
        },
        CREATOR_MINLEN() {
            return this.extInfo.CREATOR_MINLEN;
        },
        memberName() {
            return this.extInfo.memberName;
        },
        // eslint-disable-next-line vue/return-in-computed-property
        mobiTipsStyle() {
            if (this.openThemeV3) {
                return {};
            } else if (
                this.templateLayoutId != TEMPLATE_LAYOUT.NAV_AUTO &&
                this.colId == COL.CUS
            ) {
                return {
                    top: `1.5rem;`,
                };
            }
        },
        productFormId() {
            return this.extInfo.productFormId;
        },
        openCollection() {
            return this.extInfo.openCollection;
        },
        collectionClass() {
            return this.isShowCollectionHeadIcon &&
                this.sessionMid != 0 &&
                this.collectionList.includes(this.productId)
                ? ['icon-collectSelect', 'g_main_color_v3']
                : [];
        },
        knowPayVideoStyle() {
            return { 'object-fit': 'scale-down', height: '100%' };
        },
        productMallOptionContentStyle() {
            return {
                bottom: '0rem',
                'margin-bottom': '0rem',
                'padding-bottom': '0.5rem',
            };
        },
        salePointDesc() {
            return encodeHtml(this.productInfo.salePointDesc) || '';
        },
        showPointDesc() {
            return this.extInfo.isOpenPdDesc;
        },
        salePointDescClass() {
            let classList = ['salePointDesc'];
            if (
                this.mallPriceHtml !== '' ||
                this.mallMarketPriceHtml !== '' ||
                this.collectionHtml !== ''
            ) {
                classList.push('salePointDescStyle2');
            }
            return classList;
        },
        downloadModel() {
            return this.extInfo.downloadModel || {};
        },
        showFileDownload() {
            return (
                this.downloadModel.allow &&
                this.downloadModel.hasFile &&
                this.downloadModel.open
            );
        },
    },
    mounted() {
        this.useEffect();

        this.fromQz = !(
            new URLSearchParams(location.search).get('fromQz') === 'true'
        );

        this.initRealNameAuthTips();
        this.checkUrlParamsHasPaid();
    },
    methods: {
        ...mapMutations(['addMobiTips']),
        back() {
            goBack();
        },
        isEmpty(val) {
            return Array.isArray(val)
                ? val.length === 0
                : Object.keys(val).length === 0;
        },
        playVideo() {
            getProductVideo(this.productId);
        },
        quitVideo() {
            videoQuit();
        },
        getTabLiId(id) {
            return `tabLi${id}`;
        },
        getTabLiClass(index) {
            let tmp = 'tabLi';
            if (index === 0) {
                tmp += 'tabActive g_main_color_v3 g_main_bdColor_v3';
            }
            return tmp;
        },
        checkKnowPayVideoHandler(productId, finalOpener) {
            checkKnowPayVideo(productId, finalOpener);
        },
        productKnowPayVideoQuit() {
            productKnowPayVideoQuit();
        },
        bookingButtonClickHandler() {
            if (this.productFormOpen) {
                productFormBtnClick(this.productFormId, this.productId);
            }
        },
        productKnowPayBtnClickHandler() {
            productKnowPayBtnClick(this.productId);
            return false;
        },
        useEffect() {
            // 外部脚本提示
            if (this.hasThirdCode && this.oem) {
                showTopTips();
            } else if (this.hasThirdCode && !this.oem) {
                showTopTips(3);
            }

            if (
                !(
                    this.isEmptyProductInfo ||
                    (this.notAdded && !(VITE_APP_MODE !== 'visitor'))
                )
            ) {
                if (this.isShowCollectionHeadIcon) {
                    new initMbPdCollection(
                        this.sessionMid,
                        this.collectionList,
                        this.productId,
                        VITE_APP_MODE !== 'visitor'
                    ).init();
                }

                setMemberPriceLabelColot2ThemeBackgroundColor();

                Fai.top.choiceCurrencyVal = this.choiceCurrencyValPure;
                Fai.top.finallyShowPrices = this.finallyShowPrices;

                if (this.openKnowPayment) {
                    if (this.isPicTextProduct || this.isColumnProduct) {
                        if (!this.isBanCopy) {
                            initPictureSlidesV4(
                                '.swipImgBox .proDetailImg',
                                this.optionSlidePicList,
                                {
                                    fromCurentInx: true,
                                    contentTerminal: 'mobi-产品展示-产品详情',
                                }
                            );
                        } else {
                            banCurPageContentCopy();
                        }
                        initProductSwipe(
                            `productNewDetailSwipe${this.moduleId}`
                        );
                    }

                    Fai.top.bssKnowProductType = this.bssKnowProductType;
                    Fai.top.isKnowPayProduct =
                        this.isBelongToKnowPayProductAndOpenKnowPayProduct;
                } else {
                    initPictureSlidesV4(
                        '.swipImgBox .proDetailImg',
                        this.optionSlidePicList,
                        {
                            fromCurentInx: true,
                            contentTerminal: 'mobi-产品展示-产品详情',
                        }
                    );
                    if (this.showVideo) {
                        initVideo(this.productId);
                    }
                    if (this.isInitProductSwipe) {
                        initProductSwipe(
                            `productNewDetailSwipe${this.moduleId}`
                        );
                    }
                }

                initPbCommUploadImgParam(
                    this.COMMENT_UP_IMG_MAX_SIZE,
                    this.COMMENT_UP_IMG_TYPE_VALId,
                    this.siteMainDomain
                );

                if (
                    !(this.mallPriceHtml === '') ||
                    !(this.mallMarketPriceHtml === '') ||
                    !(this.collectionHtml === '')
                ) {
                    showNewMarketPrice(this.showNewMarketPrice);
                }

                if (
                    this.proSelSignValue === 'style1' ||
                    this.proSelSignValue === 'style3'
                ) {
                    setMarketingProPdStyle(this.proSelSignValue, 'isV3');
                }

                if (this.productGuaranteeOpen) {
                    productGuaranteeEventInit();
                }

                if (!this.openKnowPayment) {
                    if (this.immediatelyConsultOpen) {
                        consultImmediatelyBtnClick(
                            'consultImmediatelyBtn',
                            this.usedAdvisoryMethod,
                            this.advisoryPhone,
                            this.wechatImgPath,
                            this.mobiAdvisoryIde
                        );
                    } else {
                        consultImmediatelyBtnClick(
                            'consultImmediatelyBtn',
                            this.usedAdvisoryMethod,
                            this.advisoryPhone,
                            this.wechatImgPath
                        );
                    }
                    if (this.bookingOpen) {
                        bookingPanelClickEvent('J_productBookingBtn', 3);
                    }
                } else {
                    if (this.isBelongToColumnProduct) {
                        initCourseCatalog(
                            this.belongToColumnProductId,
                            this.productId
                        );
                    }
                }

                Fai.top.pdBtnText = this.btngroupText;
                Fai.top._productFormOpen = this.productFormOpen;
                Fai.top._knowPayProductOpen = this.openKnowPayment;
                Fai.top._isBelogToColumnProduct = this.isBelongToColumnProduct;

                if (this.showOptionList.length) {
                    initProductOptions(this.optionsInfo);
                    initOptionsStr(this.oldOptionsStr);
                }

                if (this.recommendProOpen === 0) {
                    Fai.top._productRecommentData = this.productRecommentData;
                } else {
                    Fai.top._productRecommentData = '';
                }

                if (this.openCommStar) {
                    setStarSelect();
                }

                Fai.top._shareDataProdectDetail = this.shareDataProdectDetail;

                productNewDetailEventInitV3(this.argsParam);
            }

            jm(window).bind('pageshow', function () {
                jm('#productNum').change();
            });

            bindServiceBtnEvent(this.moduleId, false);

            fixPorductDetailStyle(this.moduleId);
            initShowMallOptionImg(this.moduleId);
            initCustab(this.moduleId);
            allFixWXPA(3, this.moduleId, this.wxOpen);

            if (VITE_APP_MODE !== 'visitor') {
                Fai.top._productNewDetailExpData = this.exportData;
            }

            bindImgLazyLoad(`module${this.moduleId}`);

            setHrefEventHasReqArgs(jm(`#module${this.moduleId}`));
        },

        initRealNameAuthTips() {
            if (VITE_APP_MODE === 'visitor') {
                if (this.realNameAuth.allowShowMessage === false) {
                    this.addMobiTips(MOBILE_AUTH_TIPS);
                }
            }
        },
        checkUrlParamsHasPaid() {
            if (VITE_APP_MODE !== 'visitor') {
                return;
            }
            if (!this.isFinPay && this.sessionMid != 0) {
                if (new URLSearchParams(location.search).get('PayerID')) {
                    ing('支付结果返回中，建议多刷新几次页面查看');
                }
            }
        },
        downloadClick() {
            let manageMode = window.bizShared.context.isManageMode();
            window.bizShared.context.fdpLog('jz_product_file_click', {
                jz_content_terminal: 'mobi',
                jz_free_text1: manageMode ? '管理态' : '访客态',
                jz_free_text2: '产品详情页',
                jz_version: window.bizShared.context.jzVersion,
            });
        },
    },
};
</script>

<style>
.proImgSwipe .productBullet {
    position: absolute;
    height: 0.9rem;
    top: auto;
    bottom: 0px;
    background: rgba(0, 0, 0, 0.2);
    width: 100%;
}
.proImgSwipe .bullets {
    text-align: center;
    list-style: none;
    margin: 0;
    padding: 0;
}
.proImgSwipe .bullets li {
    display: inline-block;
    width: 0.35rem;
    height: 0.35rem;
    border-radius: 100%;
    background: #999;
    margin: 0 0.1rem;
    cursor: pointer;
    background: #adb1b1;
}
.proImgSwipe .bullets li.on {
    background: #fff;
}

.proImgSwipe {
    overflow: hidden;
    position: relative;
    margin: 0 auto;
    text-align: center;
    visibility: visible;
    margin-bottom: 0.5rem;
}
.proDetailImgBox {
    margin: 0 auto;
    margin-bottom: 0.5rem;
    overflow: hidden;
    position: relative;
    height: 100%;
}
.proDetailImg {
    vertical-align: middle;
}

.swipImgBox {
    height: 100%;
    position: relative;
    float: left;
}

.swipImgBox .bfPlay {
    width: 51px;
    height: 51px;
    top: 50%;
    left: 50%;
    background-color: rgba(0, 0, 0, 0.5);
    border-radius: 50%;
    border: none;
    position: absolute;
    margin-left: -25px;
    margin-top: -25px;
    cursor: pointer;
}
.proDetailDiv {
    text-align: center;
}
.proDetailDiv .g_button {
    width: 90%;
}
.remarkBox {
    padding: 0 0.5rem;
}

.remarkBox ol {
    padding-left: 2rem;
}
.remarkBox ul {
    padding-left: 1.35rem;
}
</style>

<style lang="scss">
.userCommentPanel .uploadify-text {
    color: #666666;
    font-family: 微软雅黑, 'microsoft yahei', 宋体, 新宋体, sans-serif;
}
.userCommentPanel .uploadify-button {
    -webkit-appearance: none;
    float: left;
    vertical-align: middle;
    display: inline-block;
    margin: 0;
    outline: none;
    cursor: pointer;
    text-align: center;
    text-decoration: none;
    font-size: 0.6rem;
    border-radius: 4px;
    margin: 0;
    padding: 0 5px !important;
    _padding: 0 4px;
    width: 40%;
    height: 1.6rem;
    _height: 28px;
    line-height: 1.4rem;
    _line-height: 32px;
    border: 1px solid #dadada;
    background-color: #f7f7f7;
    font-family: 微软雅黑, 'microsoft yahei', 宋体, 新宋体, sans-serif;
}
</style>

<style lang="scss">
@import '../../c.scss';
</style>
